import { styled } from "theme/default/styled";
import { setFlexDFJCCF1 } from "theme/setter/setFlexValues/setFlexDFJCCF1";

export const SUsersInfoPageLoader = styled.div`
  margin-top: 100px;

  ${setFlexDFJCCF1};
`;
